module.exports = __webpack_public_path__ + "static/media/Rolling-38px.59035fd3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Img/Rolling-38px.svg
// module id = 99
// module chunks = 0